module.exports = __webpack_public_path__ + "img/PER.fa924035.png";